module.exports = {"420506001":"小溪塔街道办","420506003":"东城城乡统筹发展试验区管理委员会","420506101":"樟村坪镇","420506102":"雾渡河镇","420506103":"分乡镇","420506104":"太平溪镇","420506105":"三斗坪镇","420506106":"乐天溪镇","420506107":"龙泉镇","420506108":"鸦鹊岭镇","420506109":"黄花镇","420506201":"下堡坪乡","420506202":"邓村乡","420506401":"三峡坝区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420506.json
// module id = 1729
// module chunks = 0